<div class="col-sm-12" style="text-align: center; height: 50vh; font-size: 35vh;">
    <p>{{takt}}</p>
</div>
